"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOmiseScript = exports.OMISE_SCRIPTS = void 0;
var react_1 = require("react");
exports.OMISE_SCRIPTS = {
    primary: 'https://cdn.omise.co/omise.js.gz',
    secondary: 'https://cdn2.omise.co/omise.js.gz',
};
var isBrowser = typeof window !== 'undefined';
var hasExistingScript = function (src) {
    var existingScript = document.querySelectorAll("script[src=\"" + src + "\"]");
    return existingScript.length > 0;
};
var useOmiseScript = function (scriptType) {
    if (scriptType === void 0) { scriptType = 'primary'; }
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = react_1.useState(false), error = _b[0], setError = _b[1];
    var scriptSrc = exports.OMISE_SCRIPTS[scriptType];
    react_1.useEffect(function () {
        var hasExisting = hasExistingScript(scriptSrc);
        if (!isBrowser || hasExisting) {
            return;
        }
        setLoading(true);
        var scriptElement = document.createElement('script');
        scriptElement.setAttribute('src', scriptSrc);
        scriptElement.setAttribute('type', 'text/javascript');
        var handleLoad = function () { return setLoading(false); };
        var handleError = function () {
            setLoading(false);
            setError(true);
            scriptElement.remove();
        };
        scriptElement.addEventListener('load', handleLoad);
        scriptElement.addEventListener('error', handleError);
        document.body.appendChild(scriptElement);
        return function () {
            scriptElement.removeEventListener('load', handleLoad);
            scriptElement.removeEventListener('error', handleError);
        };
    }, []);
    return [loading, error];
};
exports.useOmiseScript = useOmiseScript;
